/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React, { useMemo, useState } from 'react';
import type {
  ContentService,
  ContentChangeListener,
} from '@volkswagen-onehub/audi-content-service';
import { ContentContext } from './ContentContext';
import mockContent from '../content.json';

interface ContentContextProps {
  contentService: ContentService;
  children: React.ReactNode;
}

export const ContentContextProvider: React.FC<ContentContextProps> = ({
  contentService,
  children,
}) => {
  // TEMP SOLUTION
  const remoteContent = useMemo(() => {
    if (!contentService.getContent()) return mockContent;
    if (contentService.getContent()?.__type === 'aem-headless') return mockContent;
    return contentService.getContent();
  }, [contentService]);

  const [content, setContent] = useState(remoteContent);

  const contextValue = useMemo(() => ({ content }), [content]);

  contentService.onContentChange(setContent as ContentChangeListener);

  console.log('content inside ContentContextProvider.tsx', content);

  console.log('contextValue inside content context provider', contextValue);

  return <ContentContext.Provider value={contextValue}>{children}</ContentContext.Provider>;
};

ContentContextProvider.displayName = 'ContentContextProvider';
